exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "a:active,a:hover,a:link,a:visited{text-decoration:none!important}", "", {"version":3,"sources":["/home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-card-detail/vendor-card-detail.component.css"],"names":[],"mappings":"AAgBA,kCACE,8BAAgC,CACjC","file":"vendor-card-detail.component.css","sourcesContent":["/* unvisited link */\na:link {\n  text-decoration: none !important;\n}\n\n/* visited link */\na:visited {\n  text-decoration:none  !important;\n}\n\n/* mouse over link */\na:hover {\n  text-decoration:none !important;\n}\n\n/* selected link */\na:active {\n  text-decoration:none !important;\n}\n"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/vendor-card-detail/vendor-card-detail.component.css
// module id = PHNp
// module chunks = 0